// The one axios instance the SPA talks to the API with, reachable from code
// that has no component instance to read `this.$http` off: the Vuex actions.
//
// Under Vue 2 the store read `Vue.prototype.$http`, which main.js assigned.
// Vue 3 has no global prototype to hang that on (globalProperties live on the
// app, which the store module never sees), so main.js registers the client
// here instead, once, before anything can dispatch.
let client = null;

export function setHttpClient(instance) {
  client = instance;
}

export function getHttpClient() {
  if (!client) {
    throw new Error('httpClient: no client registered; main.js must call setHttpClient first');
  }
  return client;
}
